// Popular outstation routes with authentic Indian imagery (verified working Unsplash URLs).
export const POPULAR_ROUTES = [
    {
        from: "Satna",
        to: "Prayagraj",
        slug: "satna-to-prayagraj",
        distance: "180 km",
        distanceKm: 180,
        duration: "≈ 4 hrs",
        image: "https://images.unsplash.com/photo-1571536802807-30451e3955d8?w=1200&q=80&auto=format&fit=crop",
    },
    {
        from: "Satna",
        to: "Varanasi",
        slug: "satna-to-varanasi",
        distance: "260 km",
        distanceKm: 260,
        duration: "≈ 5.5 hrs",
        image: "https://images.unsplash.com/photo-1561361513-2d000a50f0dc?w=1200&q=80&auto=format&fit=crop",
    },
    {
        from: "Satna",
        to: "Khajuraho",
        slug: "satna-to-khajuraho",
        distance: "125 km",
        distanceKm: 125,
        duration: "≈ 3 hrs",
        image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=1200&q=80&auto=format&fit=crop",
    },
    {
        from: "Satna",
        to: "Chitrakoot",
        slug: "satna-to-chitrakoot",
        distance: "110 km",
        distanceKm: 110,
        duration: "≈ 2.5 hrs",
        image: "https://images.unsplash.com/photo-1571536802807-30451e3955d8?w=1200&q=80&auto=format&fit=crop",
    },
    {
        from: "Satna",
        to: "Rewa",
        slug: "satna-to-rewa",
        distance: "50 km",
        distanceKm: 50,
        duration: "≈ 1.5 hrs",
        image: "https://images.unsplash.com/photo-1477587458883-47145ed94245?w=1200&q=80&auto=format&fit=crop",
    },
    {
        from: "Satna",
        to: "Jabalpur",
        slug: "satna-to-jabalpur",
        distance: "190 km",
        distanceKm: 190,
        duration: "≈ 4 hrs",
        image: "https://images.unsplash.com/photo-1571536802807-30451e3955d8?w=1200&q=80&auto=format&fit=crop",
    },
    {
        from: "Satna",
        to: "Maihar",
        slug: "satna-to-maihar",
        distance: "40 km",
        distanceKm: 40,
        duration: "≈ 1 hr",
        image: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=1200&q=80&auto=format&fit=crop",
    },
    {
        from: "Satna",
        to: "Bhopal",
        slug: "satna-to-bhopal",
        distance: "410 km",
        distanceKm: 410,
        duration: "≈ 8 hrs",
        image: "https://images.unsplash.com/photo-1490644658840-3f2e3f8c5625?w=1200&q=80&auto=format&fit=crop",
    },
];

export const routeBySlug = (slug) =>
    POPULAR_ROUTES.find((r) => r.slug === slug);
